import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Raza/imprimirRaza`, method: 'POST', body: list, token: token})
}
